import { Flex } from "@chakra-ui/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_unauthenticated")({
  component: () => (
    <Flex
      minH="100vh"
      flexDirection="column"
      align={"center"}
      justify="center"
      paddingY={10}
    >
      <Outlet />
    </Flex>
  ),
});
